import React, { useCallback, useEffect, useRef, useState } from "react";
import "./style.css";
import { Input, Spin } from "antd";
import { dentalIcons } from "../../../utils-icons/dentalIcons";

import SingleCollaborator from "./SingleCollaborator";

const AddCollaborator = ({
  addCollaborator,
  remvoeCollaborator,
  examinarsData,
  loadingItemId,
  users,
}) => {
  const [search, setSearch] = useState("");

  const filteredUsers = users.filter((user) => {
    const searchLower = search.toLowerCase();
    const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
    return (
      fullName.includes(searchLower) ||
      user.email?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className="d-add-colloborator_container">
      <div className="search_input">
        <Input
          className="custom_ant-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search Collaborators"
        />
        <img
          src={dentalIcons.searchIcon}
          alt="search"
          className="input_search_icon"
        />
      </div>

      <div className="search_result_container">
        {filteredUsers.map((item, index) => {
          const isAdded = examinarsData.some(
            (examiner) => examiner.id === item.id
          );

          return (
            <SingleCollaborator
              item={item}
              key={index}
              onAdd={() => addCollaborator(item)}
              onRemove={() => remvoeCollaborator(item)}
              examinarsData={examinarsData}
              isCollaborator={isAdded}
              isLoading={loadingItemId === item.id} // Show loader only for this item
            />
          );
        })}
      </div>
    </div>
  );
};

export default AddCollaborator;
